import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Auctions_dropdown from "../../../components/dropdown/Auctions_dropdown";
import Link from "next/link";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Likes from "../../../components/likes";
import Meta from "../../../components/Meta";
import { useDispatch } from "react-redux";
import { useAppState } from "../../../components/AppContext";
import ProtectedRoute from "../../../components/ProtectedRoute";
import moment from 'moment'
const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const Item = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const pid = router.query.poet;
  const [imageModal, setImageModal] = useState(false);
  const [copy, setCopy] = useState("Copy");
  const [copyKey, setCopyKey] = useState("Copy");
  const [tokenId, setTokenId] = useState(null);

  const [data, setData] = useState({});
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const state = useAppState();
  useEffect(() => {
    if (pid) {
      setLoading(true);
      getUserArts(pid);
    }
  }, [pid]);

  const getUserArts = async (pid) => {
    try {
      const resp = await fetch(`${BASE_URL}v1/public/arts/art?id=${pid}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: "Bearer " + state.access_token,
        },
      });
      const jsonRes = await resp.json();
      setLoading(false);
      setCount(jsonRes.data.count);
      setData(jsonRes.data.response);
    } catch (e) {
      setLoading(false);
    }
  };
  const changeActiveHandler = async (e) => {
    setLoading(true);
    try {
      const resp = await fetch(`${BASE_URL}v1/user/issuer/change-poet-status`, {
        method: "POST",
        body: JSON.stringify({
          poet: data?.poet?.id,
          status: e.target.checked,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + state.access_token,
        },
      });
      const jsonRes = await resp.json();
      setLoading(false);
      getUserArts(pid);
    } catch (er) {
      console.log(er);
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="poet-overlay">
          <div className="poet-overlay__inner">
            <div className="poet-overlay__content">
              <span className="swiper-lazy-preloader"></span>
            </div>
          </div>
        </div>
      )}
      <ProtectedRoute>
        <Meta title={`${data?.poet?.collection?.name} - POET`} />
        {/*  <!-- Item --> */}
        <section className="relative lg:mt-24 lg:pt-24 lg:pb-24 mt-24 pt-12 pb-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full"
            />
          </picture>
          <div className="container">
            {/* <!-- Item --> */}
            <div className="md:flex md:flex-wrap">
              {/* <!-- Image --> */}
              <figure className="mb-8 md:w-2/5 md:flex-shrink-0 md:flex-grow-0 md:basis-auto lg:w-1/2 w-full poet-image-border square-img-container">
                <button className=" w-full" onClick={() => setImageModal(true)}>
                  <img
                    src={data?.display_media_url}
                    alt={""}
                    className="rounded-2xl-poet cursor-pointer  w-full"
                  />
                </button>

                {/* <!-- Modal --> */}
                <div
                  className={
                    imageModal ? "modal fade show block" : "modal fade"
                  }
                >
                  <div className="modal-dialog !my-0 flex h-full max-w-4xl items-center justify-center">
                    <img
                      src={data?.display_media_url}
                      alt={""}
                      className="h-full rounded-2xl"
                    />
                  </div>

                  <button
                    type="button"
                    className="btn-close absolute top-6 right-6"
                    onClick={() => setImageModal(false)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="h-6 w-6 fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                    </svg>
                  </button>
                </div>
                {/* <!-- end modal --> */}
              </figure>

              {/* <!-- Details --> */}
              <div className="md:w-3/5 md:basis-auto md:pl-8 lg:w-1/2 lg:pl-[3.75rem]">
                {/* <!-- Collection / Likes / Actions --> */}
                <div className="mb-4 flex">
                  {/* <!-- Collection --> */}
                  <div className="flex items-center">
                    <Link href="#">
                      <a className="text-accent mr-2 text-sm font-bold">
                        {data?.poet?.collection?.name}
                      </a>
                    </Link>
                    <span
                      className="dark:border-jacarta-600 bg-green inline-flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                      data-tippy-content="Verified Collection"
                    >
                      <Tippy content={<span>Verified Collection</span>}>
                        <svg className="icon h-[.875rem] w-[.875rem] fill-white">
                          <use xlinkHref="/icons.svg#icon-right-sign"></use>
                        </svg>
                      </Tippy>
                    </span>
                  </div>

                  {/* <!-- Likes / Actions --> */}
                  <div className="ml-auto flex items-stretch space-x-2 relative">
                    {/* <Likes
                      like={1}
                      classes="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 flex items-center space-x-1 rounded-xl border bg-white py-2 px-4"
                    /> */}
                    {/* <button className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white flex align-center">
                      <div>
                      <svg
                        className="icon h-[2rem] w-[3rem] fill-white "
                        version="1.1"
                        viewBox="0 -50 700 700"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m530.11 141.18c2.2266 1.082 4.1289 2.8828 5.3203 5.2695 0.058594 0.11328 0.11328 0.22656 0.16797 0.34375 0.11328 0.25 0.21875 0.50781 0.32031 0.76562 0.53516 1.4297 0.77344 2.8984 0.74609 4.3438v81.43c0 6.4453-5.2266 11.668-11.668 11.668s-11.668-5.2227-11.668-11.668v-62.789l-53.113 26.559c-5.7656 2.8828-12.773 0.54688-15.652-5.2188-2.8828-5.7617-0.54688-12.77 5.2148-15.652l49.133-24.562-49.133-24.566c-5.7617-2.8828-8.0977-9.8906-5.2148-15.652 2.8789-5.7617 9.8867-8.0977 15.652-5.2188zm6.5547 243.59c0.035156 1.7109-0.30859 3.457-1.0664 5.1094-0.57422 1.2422-1.3594 2.3789-2.3281 3.3516-0.98047 0.97656-2.0312 1.7109-3.1602 2.2617l-69.895 34.945c-5.7656 2.8828-12.773 0.54688-15.652-5.2148-2.8828-5.7656-0.54688-12.773 5.2148-15.652l49.133-24.566-49.133-24.566c-5.7617-2.8789-8.0977-9.8867-5.2148-15.652 2.8789-5.7617 9.8867-8.0977 15.652-5.2148l53.113 26.555v-62.789c0-6.4414 5.2266-11.664 11.668-11.664s11.668 5.2227 11.668 11.664zm-358.91 0.23438 49.129 24.566c5.7656 2.8789 8.1016 9.8867 5.2188 15.652-2.8828 5.7617-9.8906 8.0977-15.652 5.2148l-69.895-34.945c-2.2266-1.0859-4.1289-2.8828-5.3242-5.2695-0.054688-0.11328-0.10938-0.23047-0.16406-0.34375-0.11328-0.25-0.22266-0.50781-0.32031-0.76562-0.53906-1.4297-0.77734-2.8984-0.74609-4.3438v-81.434c0-6.4414 5.2227-11.664 11.668-11.664 6.4414 0 11.664 5.2227 11.664 11.664v62.789l53.117-26.555c5.7617-2.8828 12.77-0.54688 15.652 5.2148 2.8828 5.7656 0.54688 12.773-5.2188 15.652zm-14.422-214.46v62.789c0 6.4453-5.2227 11.668-11.664 11.668-6.4453 0-11.668-5.2227-11.668-11.668v-81.43c-0.035156-1.7148 0.30469-3.457 1.0664-5.1094 0.57031-1.2422 1.3594-2.3789 2.3281-3.3516 0.98047-0.97656 2.0273-1.7109 3.1602-2.2617l69.895-34.949c5.7617-2.8789 12.77-0.54297 15.652 5.2188 2.8828 5.7617 0.54688 12.77-5.2188 15.652l-49.129 24.566 49.129 24.562c5.7656 2.8828 8.1016 9.8906 5.2188 15.652-2.8828 5.7656-9.8906 8.1016-15.652 5.2188zm169.57-122.54c1.6211-0.85547 3.4688-1.3359 5.4258-1.3359 1.9609 0 3.8086 0.48047 5.4297 1.3359l69.789 34.895c5.7617 2.8828 8.0977 9.8906 5.2188 15.652-2.8828 5.7617-9.8906 8.0977-15.652 5.2188l-53.117-26.559v62.789c0 6.4414-5.2227 11.668-11.668 11.668-6.4414 0-11.664-5.2266-11.664-11.668v-62.789l-53.117 26.559c-5.7617 2.8789-12.77 0.54297-15.652-5.2188-2.8828-5.7617-0.54688-12.77 5.2188-15.652zm10.855 440.66c-1.6211 0.85156-3.4688 1.3359-5.4297 1.3359-1.957 0-3.8047-0.48438-5.4258-1.3359l-69.789-34.895c-5.7656-2.8828-8.1016-9.8906-5.2188-15.652 2.8828-5.7656 9.8906-8.1016 15.652-5.2188l53.117 26.559v-62.789c0-6.4453 5.2227-11.668 11.664-11.668 6.4453 0 11.668 5.2227 11.668 11.668v62.789l53.117-26.559c5.7617-2.8828 12.77-0.54688 15.652 5.2188 2.8789 5.7617 0.54297 12.77-5.2188 15.652zm6.2383-236.45v62.789c0 6.4414-5.2227 11.668-11.668 11.668-6.4414 0-11.664-5.2266-11.664-11.668v-62.789l-63.551-31.777c-5.7656-2.8789-8.1016-9.8867-5.2188-15.652 2.8828-5.7617 9.8906-8.0977 15.652-5.2148l64.781 32.391 64.785-32.391c5.7617-2.8828 12.77-0.54688 15.652 5.2148 2.8789 5.7656 0.54297 12.773-5.2188 15.652z" />
                      </svg>
                      </div>
                    </button> */}
                    <a
                      href={`${process.env.NEXT_PUBLIC_ETHERSCAN_BASEURI}address/${process.env.NEXT_PUBLIC_CONTRACT}`}
                      target="_blank"
                      className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white flex align-center w-10"
                    >
                      <div className="w-full flex justify-center">
                        <img
                          className="icon h-[2rem] w-[2rem] fill-white "
                          src="/images/chains/vitruveo-white.png"
                        />
                      </div>
                    </a>
                    {/* <a
                      href={`${process.env.NEXT_PUBLIC_OPENSEA_BASEURI}collection/${process.env.NEXT_PUBLIC_OPENSEA_COLLECTION}`}
                      target="_blank"
                      className="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white flex align-center w-10"
                    >
                      <div className="w-full flex justify-center">
                        <img
                          className="icon h-[2rem] w-[1.5rem] fill-white "
                          src="https://storage.googleapis.com/opensea-static/Logomark/Logomark-Transparent%20White.svg"
                        />
                      </div>
                    </a> */}

                    {/* <!-- Actions --> */}
                    <Auctions_dropdown classes="dark:border-jacarta-600 dark:hover:bg-jacarta-600 border-jacarta-100 dropdown hover:bg-jacarta-100 dark:bg-jacarta-700 rounded-xl border bg-white" />
                  </div>
                </div>

                <h1 className="font-display text-jacarta-700 mb-4 text-4xl font-semibold dark:text-white">
                  {data?.title}
                </h1>

                <div className="mb-8 flex items-center space-x-4 whitespace-nowrap">
                  <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                    POETs Claimed
                  </span>
                  {/* <div className="flex items-center"> */}
                  {/* <Tippy content={<span>ETH</span>}>
                    <span className="-ml-1">
                      <svg className="icon mr-1 h-4 w-4">
                        <use xlinkHref="/icons.svg#icon-ETH"></use>
                      </svg>
                    </span>
                  </Tippy> */}
                  {/* </div> */}
                  <span className="text-green text-sm font-medium tracking-tight">
                    {count} {'/'} {data?.supply}
                  </span>
                  <span className="dark:text-jacarta-300 text-jacarta-400 text-sm dark:border-jacarta-600 sm:border-jacarta-100 sm:mt-0  sm:border-l sm:pl-2 lg:pl-2">
                    Status
                  </span>
                  <input
                    type="checkbox"
                    value="checkbox"
                    name="check"
                    onChange={changeActiveHandler}
                    disabled={(data?.poet?.status == "EXPIRED" || data?.poet?.status == "PENDING"  || moment(data?.poet?.end_date).isBefore(moment())) ? true : false}
                    checked={(data?.poet?.status != "ACTIVE" || moment(data?.poet?.end_date).isBefore(moment())) ? false : true}
                    className="checked:bg-accent checked:focus:bg-accent checked:hover:bg-accent after:bg-jacarta-400 bg-jacarta-100 relative 
                    h-6 
                    w-[2.625rem] 
                    cursor-pointer appearance-none rounded-full border-none after:absolute 
                    after:top-[0.1875rem] 
                    after:left-[0.1875rem] 
                    after:h-[1.125rem] after:w-[1.125rem] 
                    after:rounded-full 
                    after:transition-all checked:bg-none
                     checked:after:left-[1.3125rem] 
                     checked:after:bg-white 
                     focus:ring-transparent focus:ring-offset-0"
                  />
                  <span
                    className={`${
                      moment(data?.poet?.end_date).isBefore(moment()) ? 
                      "text-red" :
                      data?.poet?.status == "ACTIVE"
                        ? "text-green"
                        : (data?.poet?.status == "PAUSED" || data?.poet?.status == "PENDING")
                        ? "text-warning"
                        : "text-red"
                    }   text-sm font-medium tracking-tight`}
                  >
                    {moment(data?.poet?.end_date).isBefore(moment()) ? "EXPIRED" : data?.poet?.status}
                  </span>
                </div>

                {/* <p className="dark:text-jacarta-300 mb-5">{""}</p> */}

                {/* <!-- Creator / Owner --> */}
                <div className="mb-2 flex flex-wrap">
                  <div className="mr-8 mb-4 flex">
                    <figure className="mr-4 shrink-0">
                      <Link href="/user/avatar_6">
                        <a className="relative block">
                          {data?.poet?.collection?.issuer?.display_image ? (
                            <img
                              src={
                                data?.poet?.collection?.issuer?.display_image
                              }
                              alt={""}
                              className="rounded-2lg h-12 w-12"
                              loading="lazy"
                            />
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={24}
                              height={24}
                              className=" h-8 w-8 transition-colors group-hover:fill-white group-focus:fill-white fill-white"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                            </svg>
                          )}
                          <div
                            className="dark:border-jacarta-600 bg-green absolute -right-3 top-[60%] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                            data-tippy-content="Verified Collection"
                          >
                            <Tippy content={<span>Verified Collection</span>}>
                              <svg className="icon h-[.875rem] w-[.875rem] fill-white">
                                <use xlinkHref="/icons.svg#icon-right-sign"></use>
                              </svg>
                            </Tippy>
                          </div>
                        </a>
                      </Link>
                    </figure>
                    <div className="flex flex-col justify-center">
                      <span className="text-jacarta-400 block text-sm dark:text-white">
                        Issuer
                      </span>
                      <Link href="/user/avatar_6">
                        <a className="text-accent block">
                          <span className="text-sm font-bold">
                            {data?.poet?.collection?.issuer?.name}
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>

                  <div className="mb-4 flex">
                    <figure className="mr-4 shrink-0 ">
                      <Link href="/user/avatar_6">
                        <a className="relative block">
                          {data?.user_detail?.profile_image ? (
                            <img
                              src={data?.user_detail?.profile_image}
                              alt={""}
                              className="rounded-2lg h-10 w-10"
                              loading="lazy"
                            />
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={24}
                              height={24}
                              className=" h-8 w-8 transition-colors group-hover:fill-white group-focus:fill-white fill-white"
                            >
                              <path fill="none" d="M0 0h24v24H0z" />
                              <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z" />
                            </svg>
                          )}
                          <div
                            className="dark:border-jacarta-600 bg-green absolute -right-3 top-[60%] flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                            data-tippy-content="Verified Collection"
                          >
                            <Tippy content={<span>Verified Collection</span>}>
                              <svg className="icon h-[.875rem] w-[.875rem] fill-white">
                                <use xlinkHref="/icons.svg#icon-right-sign"></use>
                              </svg>
                            </Tippy>
                          </div>
                        </a>
                      </Link>
                    </figure>
                    <div className="flex flex-col justify-center">
                      <span className="text-jacarta-400 block text-sm dark:text-white">
                        Owned by
                      </span>
                      <Link href="/user/avatar_6">
                        <a className="text-accent block">
                          <span className="text-sm font-bold">
                            {data?.user_detail?.username
                              ? data?.user_detail?.username
                              : "N/A"}
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
                <p className="js-countdown-ends-label text-jacarta-400 dark:text-jacarta-300 mb-8">
                  {data?.description}
                </p>
                {/* <!-- Bid --> */}
                <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2lg border bg-white p-8">
                  <div className="sm:flex sm:flex-wrap justify-between">
                    {/* <!-- Highest bid --> */}
                    <div className="sm:w-1/2 sm:pr-4 lg:pr-8">
                      <div className="block overflow-hidden text-ellipsis whitespace-nowrap">
                        <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                          POET Claim Link{" "}
                        </span>
                        {/* <Link href="/user/avatar_6">
                          <a className="text-accent text-sm font-bold">
                            0x695d2ef170ce69e794707eeef9497af2de25df82
                          </a>
                        </Link> */}
                      </div>
                      <div className="mt-3 flex">
                        {/* <figure className="mr-4 shrink-0 ">
                          <Link href="#">
                            <a className="relative block">
                              <img
                                src="/images/avatars/avatar_4.jpg"
                                alt="avatar"
                                className="rounded-2lg h-12 w-12"
                                loading="lazy"
                              />
                            </a>
                          </Link>
                        </figure> */}
                        <div>
                          <div className="flex items-center whitespace-nowrap">
                            {/* <Tippy content={<span>Status</span>}>
                              <span className="-ml-1">
                                <svg className="icon mr-1 h-4 w-4">
                                  <use xlinkHref="/icons.svg#icon-ETH"></use>
                                </svg>
                              </span>
                            </Tippy> */}
                            {typeof window !== "undefined" && (
                              <span className="text-green text-lg font-medium leading-tight tracking-tight poet-link">
                                {window?.location.origin.toString() +
                                  "?poet=" +
                                  data?.poet?.poet_phrase}
                              </span>
                            )}
                          </div>
                          {/* <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                            {data?.poet?.status}
                          </span> */}
                        </div>
                      </div>
                    </div>

                    {/* <!-- Countdown --> */}
                    {/* <div className="dark:border-jacarta-600 sm:border-jacarta-100 mt-4 sm:mt-0 sm:w-1/2 sm:border-l sm:pl-4 lg:pl-8">
                      <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                        Status{" "}
                      </span>

                      <div className="mt-3 flex">
                        <figure className="mr-4 shrink-0 ">
                          <Link href="#">
                            <a className="relative block">
                              <img
                                src="/images/avatars/avatar_4.jpg"
                                alt="avatar"
                                className="rounded-2lg h-12 w-12"
                                loading="lazy"
                              />
                            </a>
                          </Link>
                        </figure>
                        <div>
                          <div className="flex items-center whitespace-nowrap">
                            <Tippy content={<span>Status</span>}>
                              <span className="-ml-1">
                                <svg className="icon mr-1 h-4 w-4">
                                  <use xlinkHref="/icons.svg#icon-ETH"></use>
                                </svg>
                              </span>
                            </Tippy>
                            <span className="text-green text-lg font-medium leading-tight tracking-tight">
                              {""} Claimed
                              {data?.poet?.status}
                            </span>
                          </div>
                          <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                            {count}
                          </span>
                        </div>
                      </div>
                    </div> */}
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(
                          window?.location.origin.toString() +
                            "?poet=" +
                            data?.poet?.poet_phrase
                        );
                        setCopy("Copied");
                        setTimeout(() => {
                          setCopy("Copy");
                        }, 2000);
                      }}
                      className="inline-block mt-6 flex align-center rounded-full bg-accent py-2 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
                      type="button"
                    >
                      <span className="mr-2 mb-1"> {copy}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="dark:fill-jacarta-300 fill-jacarta-500 ml-auto mb-px h-4 w-4"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z"></path>
                      </svg>
                    </button>
                  </div>
                  <div className="sm:flex sm:flex-wrap justify-between pt-5">
                    {/* <!-- Highest bid --> */}
                    <div className="sm:w-1/2 sm:pr-4 lg:pr-8">
                      <div className="block overflow-hidden text-ellipsis whitespace-nowrap">
                        <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                          POET Key{" "}
                        </span>
                        {/* <Link href="/user/avatar_6">
                          <a className="text-accent text-sm font-bold">
                            0x695d2ef170ce69e794707eeef9497af2de25df82
                          </a>
                        </Link> */}
                      </div>
                      <div className="mt-3 flex">
                        {/* <figure className="mr-4 shrink-0 ">
                          <Link href="#">
                            <a className="relative block">
                              <img
                                src="/images/avatars/avatar_4.jpg"
                                alt="avatar"
                                className="rounded-2lg h-12 w-12"
                                loading="lazy"
                              />
                            </a>
                          </Link>
                        </figure> */}
                        <div>
                          <div className="flex items-center whitespace-nowrap">
                            {/* <Tippy content={<span>Status</span>}>
                              <span className="-ml-1">
                                <svg className="icon mr-1 h-4 w-4">
                                  <use xlinkHref="/icons.svg#icon-ETH"></use>
                                </svg>
                              </span>
                            </Tippy> */}
                            {typeof window !== "undefined" && (
                              <span className="text-green text-lg font-medium leading-tight tracking-tight">
                                {data?.poet?.poet_phrase}
                              </span>
                            )}
                          </div>
                          {/* <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                            {data?.poet?.status}
                          </span> */}
                        </div>
                      </div>
                    </div>

                    {/* <!-- Countdown --> */}
                    {/* <div className="dark:border-jacarta-600 sm:border-jacarta-100 mt-4 sm:mt-0 sm:w-1/2 sm:border-l sm:pl-4 lg:pl-8">
                      <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                        Status{" "}
                      </span>

                      <div className="mt-3 flex">
                        <figure className="mr-4 shrink-0 ">
                          <Link href="#">
                            <a className="relative block">
                              <img
                                src="/images/avatars/avatar_4.jpg"
                                alt="avatar"
                                className="rounded-2lg h-12 w-12"
                                loading="lazy"
                              />
                            </a>
                          </Link>
                        </figure>
                        <div>
                          <div className="flex items-center whitespace-nowrap">
                            <Tippy content={<span>Status</span>}>
                              <span className="-ml-1">
                                <svg className="icon mr-1 h-4 w-4">
                                  <use xlinkHref="/icons.svg#icon-ETH"></use>
                                </svg>
                              </span>
                            </Tippy>
                            <span className="text-green text-lg font-medium leading-tight tracking-tight">
                              {""} Claimed
                              {data?.poet?.status}
                            </span>
                          </div>
                          <span className="dark:text-jacarta-300 text-jacarta-400 text-sm">
                            {count}
                          </span>
                        </div>
                      </div>
                    </div> */}
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(data?.poet?.poet_phrase);
                        setCopyKey("Copied");
                        setTimeout(() => {
                          setCopyKey("Copy");
                        }, 2000);
                      }}
                      className="inline-block mt-6 flex align-center rounded-full bg-accent py-2 px-8 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
                      type="button"
                    >
                      <span className="mr-2 mb-1"> {copyKey}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        className="dark:fill-jacarta-300 fill-jacarta-500 ml-auto mb-px h-4 w-4"
                      >
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.993c0 .556-.449 1.007-1.007 1.007H3.007A1.006 1.006 0 0 1 2 20.993l.003-12.986C2.003 7.451 2.452 7 3.01 7H7zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3zM4.003 9L4 20h11V9H4.003z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
                {/* <!-- end bid --> */}
              </div>
              {/* <!-- end details --> */}
            </div>
            {/* <ItemsTabs /> */}
          </div>
        </section>
        {/* <!-- end item --> */}

        {/* <More_items /> */}
      </ProtectedRoute>
    </>
  );
};

export default Item;
